module.exports = __webpack_public_path__ + "static/58gde-aa88fd16d5e0caa8b015fb5b13060900.gif";